import { apiSlice } from "../api/apiSlice";
import {
  CustomerDetailsListAction
} from "./customerslice";

export const customerApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      addCustomer: builder.query({
        query: (body) => ({
          url: "Organizations",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

      editCustomer: builder.query({
        query: (body) => ({
          url: "organizations/UpdateOrganizationsV2",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

      getCRMCustomerDetailsList: builder.query({
        query: ({ CompanyId, CustomerType, IsArchive, ContractTypeID }) =>
          `CRMClient/GetCustomerDetailsList?CompanyId=${CompanyId ?? ""}&CustomerType=${
            CustomerType ?? ""}&IsArchive=${
            IsArchive ?? ""}&ContractTypeID=${
            ContractTypeID ?? ""
          }`,
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
            const result = await queryFulfilled;
            if (result.data.data?.length > 0) {
              dispatch(
                CustomerDetailsListAction({
                  CustomerDetailsList: result.data.data,
                })
              );
            }
          } catch (err) {}
        },
      }),

      archiveCustomer: builder.query({
        query: (body) => ({
          url: "organizations/ArchiveToggleCustomer",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

    }),
  });
  
  export const {
    useLazyAddCustomerQuery,
    useLazyEditCustomerQuery,
    useLazyGetCRMCustomerDetailsListQuery,
    useLazyArchiveCustomerQuery
  } = customerApi;
  